import { Card, CardContent, Avatar, Typography, Button, useTheme, alpha } from '@mui/material';
import { Group as GroupIcon, PersonAdd as PersonAddIcon } from '@mui/icons-material';
import { useI18nContext } from '@/i18n/i18n-react';

interface EmptyStateProps {
    filterMode: 'all' | 'active' | 'inactive' | 'admin';
    onAddUser: () => void;
}

export const EmptyState = ({ filterMode, onAddUser }: EmptyStateProps) => {
    const theme = useTheme();
    const { LL } = useI18nContext();

    const getMessage = () => {
        switch (filterMode) {
            case 'all':
                return LL.emptyState.addFirstUser();
            case 'active':
                return LL.emptyState.noActiveUsers();
            case 'inactive':
                return LL.emptyState.noInactiveUsers();
            case 'admin':
                return LL.emptyState.noAdmins();
            default:
                return LL.emptyState.noUsers();
        }
    };

    return (
        <Card sx={{ mt: 4, textAlign: 'center', py: 8 }}>
            <CardContent>
                <Avatar
                    sx={{
                        width: 80,
                        height: 80,
                        bgcolor: alpha(theme.palette.primary.main, 0.1),
                        color: 'primary.main',
                        margin: '0 auto',
                        mb: 2,
                    }}
                >
                    <GroupIcon sx={{ fontSize: 40 }} />
                </Avatar>
                <Typography variant="h5" gutterBottom>
                    {LL.emptyState.noUsers()}
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                    {getMessage()}
                </Typography>
                {filterMode === 'all' && (
                    <Button variant="contained" startIcon={<PersonAddIcon />} onClick={onAddUser}>
                        {LL.emptyState.addFirstUser()}
                    </Button>
                )}
            </CardContent>
        </Card>
    );
};
